import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import NProgress from 'nprogress';

const LoadingBar = () => {
  const location = useLocation();

  useEffect(() => {
    NProgress.configure({ 
      showSpinner: false,
      minimum: 0.1,
      speed: 500,
      easing: 'ease'
    });

    NProgress.start();
    
    // Complete the progress bar after a short delay
    const timer = setTimeout(() => {
      NProgress.done();
    }, 500);

    return () => {
      clearTimeout(timer);
      NProgress.remove();
    };
  }, [location]);

  return null;
};

export default LoadingBar; 